import MUIDivider from '@mui/material/Divider';

export const Divider = MUIDivider;
